import React, { useState, useRef, useEffect } from "react";

import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";

function IconButton({ children, title, onClick }) {
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      className="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-slate-300 tw-bg-white tw-text-xs tw-text-slate-700 hover:tw-bg-slate-50"
    >
      {children}
    </button>
  );
}

export default function RawOnOffReport({ filters, range, fetchRawData }) {
  const [openDropdown, setOpenDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setOpenDropdown((prev) => !prev);

  const handleDownloadPDF = () => {
    setOpenDropdown(false);
    console.log("Download PDF triggered");
  };

  const handleDownloadCSV = () => {
    setOpenDropdown(false);
    console.log("Download CSV triggered");
  };

  useEffect(() => {
    if (fetchRawData) {
      fetchRawData()
        .then((data) => {
          if (data) {
            console.log("Raw Data Fetched:", data);
          }
        })
        .catch((err) => console.error("Failed to fetch raw data", err));
    }
  }, [filters, range, fetchRawData]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(false);
      }
    }

    if (openDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown]);

  return (
    <div className="tw-flex tw-flex-col tw-h-full tw-gap-4">
      <div className="tw-flex tw-items-center tw-justify-end tw-relative">
        <div className="tw-flex tw-items-center tw-gap-2">
          <IconButton title="Favourite">
            <FavoriteBorderIcon fontSize="small" />
          </IconButton>

          <IconButton title="Full screen">
            <FullscreenIcon fontSize="small" />
          </IconButton>

          <IconButton title="Print chart">
            <PrintIcon fontSize="small" />
          </IconButton>

          <div className="tw-relative" ref={dropdownRef}>
            <IconButton title="Download options" onClick={toggleDropdown}>
              <DownloadIcon fontSize="small" />
            </IconButton>

            {openDropdown && (
              <div className="tw-absolute tw-right-0 tw-mt-1 tw-w-40 tw-bg-white tw-border tw-border-slate-200 tw-rounded-md tw-shadow-lg tw-z-30">
                <button
                  onClick={handleDownloadPDF}
                  className="tw-block tw-w-full tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-text-slate-700 hover:tw-bg-slate-100"
                >
                  Download as PDF
                </button>
                <button
                  onClick={handleDownloadCSV}
                  className="tw-block tw-w-full tw-text-left tw-px-3 tw-py-2 tw-text-xs tw-text-slate-700 hover:tw-bg-slate-100"
                >
                  Download as CSV
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="tw-flex-1 tw-rounded-lg tw-bg-slate-50 tw-border tw-border-slate-200 tw-p-4 tw-flex tw-items-center tw-justify-center">
        <span className="tw-text-xs tw-text-slate-400">
          Raw On-Off chart will be rendered here. (range:{" "}
          {Array.isArray(range) ? `${range[0]} – ${range[1]}` : "N/A"} )
        </span>
      </div>
    </div>
  );
}
